import { forwardRef } from 'react'
import { keyboardEvents } from '../../../utils/keyboardEvents'

const FocusableContainer = forwardRef(({ children, className = '', onKeyDown, onClick, ...props }, ref) => {
  return (
    <div
      ref={ref}
      tabIndex={0}
      role="button"
      className={className}
      onClick={onClick}
      onKeyDown={(event) => (onKeyDown ? onKeyDown(event) : event.key === keyboardEvents.ENTER && onClick(event))}
      {...props}
    >
      {children}
    </div>
  )
})

export default FocusableContainer
